import DeleteController from "csi/action/DeleteController";
import { C8Node } from "csi/typings";
import declare from "dojo/_base/declare";

const AffectedItemsGroupDeleteController = declare(DeleteController, {
	/**
	 * @override
	 * Set group url to affected item instead of temp node
	 */
	toWriter() {
		const tempNodeURL = this.m_urlNode;
		const cache = this.m_cache;
		const tempNode = cache.getNode(tempNodeURL);
		//gets the first Impacted Item Node related to current Affected Item
		const childImpactedItemNode: C8Node = tempNode ? cache.getNode(tempNode?._refs.first()) : null;
		//the Impacted Item Node should have parent path to Affected Item instead of temp node
		this.m_urlNode = childImpactedItemNode ? cache.getNode(childImpactedItemNode?.__Parent__).$URL : tempNodeURL;
		this.inherited(arguments);
		this.m_urlNode = tempNodeURL;
	},
});

export = AffectedItemsGroupDeleteController;